import anime from 'animejs';
const elements = document.querySelectorAll<HTMLElement>('[data-lang-menu]');

elements.forEach((el) => {
	const button = el.querySelector('button');
	const list = el.querySelector('ul');

	if (!button || !list) return;

	const items = list.querySelectorAll('li');

	const currentItems = Array.from(items)
		.map((item) => {
			return item.querySelector('a[aria-current="page"]')?.textContent;
		})
		.filter((value): value is string => typeof value === 'string');

	if (currentItems.length > 0) {
		button.textContent = currentItems[0];
	}

	let opened = false;

	const animation = anime.timeline({
		direction: 'alternate',
		autoplay: false,
		loop: false,
		complete() {
			if (animation.progress === 0) {
				list.style.display = 'none';
			}
		},
	});

	animation.add(
		{
			targets: list,
			opacity: [0, 1],
			easing: 'linear',
			duration: 50,
		},
		0,
	);

	animation.add(
		{
			targets: items,
			translateY: {
				value: ['-1.5rem', '0rem'],
				easing: 'cubicBezier(0, 1, 0.2, 1)',
			},
			opacity: {
				value: [0, 1],
				easing: 'linear',
			},
			duration: 150,
			delay: (_, i, a) => i * 70,
		},
		0,
	);

	const open = () => {
		opened = true;
		list.style.display = 'block';
		button.setAttribute('aria-expanded', 'true');
		button.setAttribute('aria-pressed', 'true');

		if (animation.reversed) {
			animation.reverse();
		}

		animation.play();
	};

	const close = () => {
		opened = false;
		button.setAttribute('aria-expanded', 'false');
		button.setAttribute('aria-pressed', 'false');
		if (!animation.reversed) {
			animation.reverse();
		}
		animation.play();
	};

	button.addEventListener('click', () => {
		if (opened) {
			close();
		} else {
			open();
		}
	});

	// Close when clicking outside the element
	document.addEventListener('click', (ev) => {
		if (ev.target instanceof Node && !el.contains(ev.target) && opened) {
			close();
		}
	});

	// Close when pressing Escape
	document.addEventListener('keyup', (ev) => {
		if (ev.key === 'Escape' && opened) {
			button.focus();
			close();
		}
	});

	// Close when tabbing out of the menu
	document.addEventListener('focusin', (ev) => {
		if (ev.target instanceof Node && !el.contains(ev.target) && opened) {
			close();
		}
	});
});
